import { atom, selector } from 'recoil';

export const progressBarValues = atom<Map<number, boolean|number>>({
    key: 'progressBarValues',
    default: new Map(),
});

export const progressBarNumberValue = selector<number>({
    key: 'progressBarNumberValue',
    get: ({ get }) => {
        const valuesMap = get(progressBarValues);
        //@ts-ignore
        const values:[number, number|boolean][] = [...valuesMap.entries()];
        const loadingSections = values.length;

        return values.reduce<number>((acc, [, value]) => {
            let forcedSectionValue: number;

            if (typeof value === 'boolean') {
                if (value)
                    forcedSectionValue = 100;
                else
                    forcedSectionValue = 0;
            }
            else {
                forcedSectionValue = value;
            }

            return acc + (100/loadingSections)*(forcedSectionValue/100);
        }, 0);
    },
});

export const progressBarVisibility = selector<boolean>({
    key: 'progressBarVisibility',
    get: ({ get }) => {
        const valuesMap = get(progressBarValues);
        //@ts-ignore
        const values:[number, number|boolean][] = [...valuesMap.entries()];

        return !!values.find(([, val]) => !!val);
    },
});

export const progressInfiniteMode = atom<boolean>({
    key: 'progressInfiniteMode',
    default: true,
});
